import axios from "axios";

export function heritageApiErrorMessage(error: unknown): string | null {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (data && typeof data === "object" && data !== null) {
      const details = (data as { details?: unknown }).details;
      if (typeof details === "string" && details.trim()) {
        return details.trim();
      }
      const m = (data as { message: unknown }).message;
      if (typeof m === "string" && m.trim()) return m.trim();
    }
    if (typeof data === "string" && data.trim()) return data.trim();
    const status = error.response?.status;
    if (status != null) {
      return `Request failed (${status}).`;
    }
  }
  if (error instanceof Error && error.message) return error.message;
  return null;
}
